import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';

import { EUSSStatus, ITag } from 'types';
import { EUSSIndicator } from '../../../atoms/icons/EUSSIndicator';
import { useTranslation } from "react-i18next";

export const EussGrantedTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  return (
    <Tooltip hasArrow placement="bottom" label={<EUSSGrantedHover eussStatus={tag.eussStatus!} />}>
      <Tag size="xs" variant="solid" data-selector="tag-euss-granted" {...tagProps}>
        <Box mr="0.5">
          <EUSSIndicator />
        </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const EUSSGrantedHover = ({ eussStatus }: { eussStatus: EUSSStatus }) => {
    const { t } = useTranslation('common');
  return (
    <>
      {t('common:statusGrantedUnderEuSettlementSc')} <br />
      <b>{eussStatus}</b>
    </>
  );
};
